export * from "./global-footer";
export * from "./global-footer-top";
export * from "./global-footer-bottom";
export { GlobalFooter as default } from "./global-footer";
